import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize } from '../pvd-utils/enums/size.js';

var LabelVariant;
(function (LabelVariant) {
    LabelVariant["primary"] = "primary";
    LabelVariant["secondary"] = "secondary";
})(LabelVariant || (LabelVariant = {}));
var LabelIndicator;
(function (LabelIndicator) {
    LabelIndicator["optional"] = "optional";
    LabelIndicator["required"] = "required";
})(LabelIndicator || (LabelIndicator = {}));
var DEFAULT_INDICATOR_OPTIONAL_TEXT = 'optional';
var DEFAULT_SIZE = StandardSize.medium;
var DEFAULT_VARIANT = LabelVariant.primary;
var LABEL_PROTECTED_ATTR_MAP = new Map([['for', 'pvd-for']]);
/**
 * Providence Label component.
 * @see {@link https://providence.fmr.com/components/label/label.html|Label documentation}
 */
var PvdLabel = /** @class */ (function (_super) {
    __extends(PvdLabel, _super);
    function PvdLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdIndicatorOptionalText = DEFAULT_INDICATOR_OPTIONAL_TEXT;
        _this.pvdSize = DEFAULT_SIZE;
        _this.pvdVariant = DEFAULT_VARIANT;
        return _this;
        // #endregion
    }
    // #endregion
    // #region private methods
    /**
     * Sets attributes on the label element that are coming from pvdNativeLabelAttributes
     * @param prevAttr optional, if user updates pvdNativeLabelAttributes, this will remove/update existing attributes
     */
    PvdLabel.prototype.setNativeLabelAttributes = function (prevAttr) {
        var targetElement = this.querySelector('label');
        this.setNativeAttributes(this.pvdNativeLabelAttributes, LABEL_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    };
    // #endregion
    // #region LitElement lifecycles
    PvdLabel.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (this.pvdNativeLabelAttributes) {
            var prevAttr = changedProperties.get('pvdNativeLabelAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeLabelAttributes(prevAttr);
        }
    };
    /**
     * Render native label element only if the consumer provided a for
     * attribute; otherwise, style a div as a label. This allows for the
     * Providence Label component to label a group as well as a form
     * control.
     */
    PvdLabel.prototype.renderLabel = function (text) {
        return this.pvdFor
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<label class=\"pvd-label__label\" for=\"", "\">", "</label>"], ["<label class=\"pvd-label__label\" for=\"", "\">", "</label>"])), this.pvdFor, text) : x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<div class=\"pvd-label__label\" id=\"", "\">", "</div>"], ["<div class=\"pvd-label__label\" id=\"", "\">", "</div>"])), l(this.pvdId), text);
    };
    PvdLabel.prototype.renderIndicator = function () {
        switch (this.pvdIndicator) {
            case LabelIndicator.required:
                return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<span\n          aria-hidden=\"true\"\n          class=\"pvd-label__indicator pvd-label__indicator--required\"\n          >*</span\n        >"], ["<span\n          aria-hidden=\"true\"\n          class=\"pvd-label__indicator pvd-label__indicator--required\"\n          >*</span\n        >"])));
            case LabelIndicator.optional:
                return x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<span class=\"pvd-label__indicator\">(", ")</span>"], ["<span class=\"pvd-label__indicator\">(", ")</span>"])), this.pvdIndicatorOptionalText);
            default:
                return x(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
        }
    };
    PvdLabel.prototype.renderAnnotation = function () {
        return this.isSlotUsed('annotation')
            ? x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["<span class=\"pvd-label__annotation\"><s-slot name=\"annotation\"></s-slot></span>"], ["<span class=\"pvd-label__annotation\"><s-slot name=\"annotation\"></s-slot></span>"]))) : x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["<s-slot name=\"annotation\"></s-slot>"], ["<s-slot name=\"annotation\"></s-slot>"])));
    };
    PvdLabel.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-label-root"),
            modifierPrefix: 'pvd-label',
            modifiers: [
                {
                    condition: this.pvdSize !== StandardSize.small,
                    className: "".concat(this.pvdSize),
                },
                {
                    condition: true,
                    className: this.pvdVariant,
                },
            ],
        };
        var indicator = this.renderIndicator();
        var annotation = this.renderAnnotation();
        var text = x(templateObject_8 || (templateObject_8 = __makeTemplateObject([" <s-slot>", "</s-slot>", "", ""], [" <s-slot>", "</s-slot>", "", ""])), this.pvdText, indicator, annotation);
        return x(templateObject_9 || (templateObject_9 = __makeTemplateObject([" <div class=\"", "\">", "</div> "], [" <div class=\"", "\">", "</div> "])), getClassName(classMap), this.renderLabel(text));
    };
    //#region Component configuration
    PvdLabel.componentName = 'label';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-for' }),
        __metadata("design:type", String)
    ], PvdLabel.prototype, "pvdFor", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-id' }),
        __metadata("design:type", String)
    ], PvdLabel.prototype, "pvdId", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-indicator' }, PvdSlotifyBaseComponent.hasChanged(LabelIndicator))),
        __metadata("design:type", String)
    ], PvdLabel.prototype, "pvdIndicator", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-indicator-optional-text',
        }),
        __metadata("design:type", String)
    ], PvdLabel.prototype, "pvdIndicatorOptionalText", void 0);
    __decorate([
        n({ type: Object, attribute: 'pvd-native-label-attributes' }),
        __metadata("design:type", Object)
    ], PvdLabel.prototype, "pvdNativeLabelAttributes", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdSlotifyBaseComponent.hasChanged([StandardSize.medium, StandardSize.large]))),
        __metadata("design:type", Number)
    ], PvdLabel.prototype, "pvdSize", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-text' }),
        __metadata("design:type", String)
    ], PvdLabel.prototype, "pvdText", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-variant' }, PvdSlotifyBaseComponent.hasChanged(LabelVariant))),
        __metadata("design:type", String)
    ], PvdLabel.prototype, "pvdVariant", void 0);
    return PvdLabel;
}(PvdSlotifyBaseComponent));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { DEFAULT_INDICATOR_OPTIONAL_TEXT, DEFAULT_SIZE, DEFAULT_VARIANT, LABEL_PROTECTED_ATTR_MAP, LabelIndicator, LabelVariant, PvdLabel };
